require.context("../images", true);
globalThis.toggleRow = function toggleRow(cell) {
  const innerRow = cell.closest("tr").nextElementSibling;
  const isHidden = innerRow.classList.toggle("hidden");
  const toggleSym = isHidden ? "\u25B6" : "\u25BC";
  cell.textContent = toggleSym;
};
globalThis.toggleSectors = function toggleSectors(btn) {
  const list = btn.closest("[data-sectors]");
  const items = list.querySelectorAll("[data-sector-item]");
  const limit = Number.parseInt(list.dataset.limit || "5", 10);
  const expanded = list.dataset.expanded === "true";
  items.forEach(function(item, i) {
    if (i >= limit) item.style.display = expanded ? "none" : "";
  });
  list.dataset.expanded = String(!expanded);
  const labelEl = btn.querySelector("[data-label]");
  if (labelEl) {
    labelEl.textContent = expanded ? labelEl.dataset.moreText || "Ver mais" : labelEl.dataset.lessText || "Ver menos";
  }
  const iconEl = btn.querySelector("[data-icon]");
  if (iconEl) iconEl.textContent = expanded ? "\u25BC" : "\u25B2";
};
